import { memo } from "react";
import PurchasePageTitle from "../../components/PurchasePageTitle";
import NewCreditCardDataSection from "../../components/NewCreditCardDataSection";
import { useSearchParams } from "react-router-dom";
import { useUser } from "../../../../../contexts/userContext/userContext";
import type { BillingDetailsT } from "../../../../../models/models";

import styles from "./styles.module.scss";

const PurchaseFailed = memo(() => {
  const [searchParams] = useSearchParams();
  const { getUserBillingDetails } = useUser();
  const userBillingDetails = getUserBillingDetails() as BillingDetailsT;

  return (
    <>
      <PurchasePageTitle />
      <div />
      <div className={styles.purchaseBodyContainer}>
        <NewCreditCardDataSection
          isFailed
          t={searchParams.get("t") || ""}
          token={userBillingDetails?.token_id}
        />
        <div className={styles.purchaseBodyDetails}></div>
      </div>
    </>
  );
});

export default PurchaseFailed;
